import { useAnalysisModels } from '../../queries/meetingAnalysis';
import { analysisTypeLabel } from '../../lib/history-performance';

/**
 * Compact "which model is in which slot" indicator for a meeting card — the
 * at-a-glance T1/T2 model pills the old admin showed inline in the list.
 * Fetched lazily (only when the meeting actually has analysis) so meetings with
 * no tips don't each fire a request.
 */
export function MeetingModelSlots({ meetingId, hasAnalysis }: { meetingId: string; hasAnalysis: boolean }) {
  const { data: models = [] } = useAnalysisModels(meetingId, hasAnalysis);

  if (!hasAnalysis || models.length === 0) return null;

  return (
    <div className="mt-2 flex flex-wrap items-center gap-1.5">
      {models.map((m) => (
        <span
          key={m.analysis_type_id}
          className="inline-flex items-center gap-1 rounded-md border border-border bg-muted/50 px-2 py-0.5 text-xs"
          title={`${analysisTypeLabel(m.analysis_type_id)} — ${m.ai_model ?? 'unknown model'}${m.ai_version ? ` ${m.ai_version}` : ''}`}
        >
          <span className="font-semibold text-primary">{`T${m.analysis_type_id}`}</span>
          <span className="font-medium text-foreground">{m.ai_model ?? '—'}</span>
          {m.ai_version && <span className="font-mono text-[10px] text-muted-foreground">{m.ai_version}</span>}
        </span>
      ))}
    </div>
  );
}
